<div class="container">
    <div class="headline">
        <app-spot-headline *ngIf="data.headlineText as headlineText" [index]="data.spotIndex">
            {{ headlineText }}
        </app-spot-headline>
    </div>
    <div
        class="row-wrapper"
        [class.row-wrapper--center]="numOfItems <= 6"
        *ngIf="data?.entrances?.length as numOfItems"
    >
        <ng-container *ngFor="let item of data?.entrances">
            <article class="item">
                <div class="item-content">
                    <app-image
                        [image]="item.image"
                        [height]="350"
                        [width]="350"
                        [index]="data.spotIndex"
                        crop="crop"
                        *ngIf="item.image"
                    ></app-image>

                    <app-link [link]="item.link" [cover]="true" *ngIf="item.link">
                        <span class="kk-visuallyhidden" *ngIf="item.link?.name as name"> {{ name }} </span>
                    </app-link>
                    <footer>
                        <h3 class="title kk-overflow-ellipsis" *ngIf="item.link?.name as name">{{ name }}</h3>
                        <div class="arrow kk-float-horizontally-right">
                            <app-svg-icon iconName="arrow_right"></app-svg-icon>
                        </div>
                    </footer>
                </div>
            </article>
        </ng-container>
    </div>
</div>
